import React from 'react';
import loadingStyle from '../LoadingOverlay.module.css';

const Svg = (props) => (
    <svg viewBox='25 25 50 50' className={loadingStyle.svgLoading}>
        {props.children}
    </svg>
);

export default Svg;
